// import HomeOne from "../components/homes/home";
// import MobileMenu from "../components/layout/component/MobileMenu";

import HomeHero from "../components/homes/heros/HomeHero";
import Preloader from "../components/common/Preloader";

import MetaComponent from "../components/common/MetaComponent";

const metadata = {
  title:
    "Home-1 || gvkEDU: Pioneer in pharmacy education",
  description:
    "Elevate your e-learning content with gvkEDU, the most impressive LMS template for online courses, education and LMS platforms.",
};

export default function HomePage1() {
  return (
    <>
      <Preloader />
      <MetaComponent meta={metadata} />

      <HomeHero />
      {/* <Brands /> */}
      {/* <Categories /> */}
      {/* <Courses /> */}
      {/* <TestimonialsOne /> */}
      {/* <FeaturesOne /> */}
      {/* <WhyCourse /> */}
      {/* <Instructors /> */}
      {/* <Blog /> */}
      {/* <Join /> */}
 
    </>
  );
}
